import { render, staticRenderFns } from "./renstra_arah_kebijakan.vue?vue&type=template&id=91d0e24a&"
import script from "./renstra_arah_kebijakan.vue?vue&type=script&lang=js&"
export * from "./renstra_arah_kebijakan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports